import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  resetChannels({ commit }) {
    commit(types.RESET_CHANNELS)
  },
  resetMessages({ commit }) {
    commit(types.RESET_MESSAGES)
  },
  resetUsers({ commit }) {
    commit(types.RESET_USERS)
  },
  setNewMembers({ commit }, data) {
    commit(types.SET_NEW_MEMBERS, data)
  },
  setCurrentChannel({ commit }, data) {
    commit(types.SET_CURRENT_CHANNEL, data)
  },
  async listChannels({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'listChannels', () =>
      http.get('chat/chatChannels', {
        params: searchOptions
      })
    )
    commit(types.SET_CHANNELS, r.data)
    return r.data
  },
  async getChannelInfo({ commit, dispatch }, data) {
    console.log('Calling chatChannel', data)
    const r = await startLoading(dispatch, 'getChannelInfo', () =>
      http.get(`chat/chatChannel?channel=${data.channel}&show_member=${data.showMembers}&show_metadata=${data.showMetadata}`)
    )
    commit(types.SET_CHANNEL, r.data)
    return r.data
  },
  async getChannelMetadata({ commit, dispatch }, url) {
    // chatChannelMetadata
    const r = await startLoading(dispatch, 'getChannelMetadata', () => http.get(`chat/chatChannelMetadata?channel=${url}`))
    commit(types.SET_CHANNEL_METADATA, r.data)
    return r.data
  },
  async getMessages({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getMessages', () =>
      http.get('chat/chatMessages', {
        params: searchOptions
      })
    )
    commit(types.SET_MESSAGES, r.data)
    return r.data
  },
  async archiveChannel({ commit, dispatch }, channel) {
    const r = await startLoading(dispatch, 'archiveChannel', () => http.post(`chat/archiveChannel?channel=${channel}`))
    return r.data
  },
  async joinChannel({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'joinChannel', () => http.get(`chat/joinChannel?channel=${data.channel}&guid=${data.guid}`))
    return r.data
  },
  async leaveChannel({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'leaveChannel', () => http.get(`chat/leaveChannel?channel=${data.channel}&guids=${data.guids}`))
    return r.data
  },
  async searchChatUsers({ commit, dispatch }, data) {
    commit(types.RESET_FOUND_MEMBERS)
    const r = await startLoading(dispatch, 'searchChatUsers', () => http.get(`chat/searchUsers?firm=${data.firm}&search=${data.search}`))
    commit(types.SET_FOUND_MEMBERS, r.data)
    return r.data
  },
  async searchChatMembers({ commit, dispatch }, name) {
    commit(types.RESET_FOUND_MEMBERS)
    const r = await startLoading(dispatch, 'searchChatMembers', () =>
      http.get(`chat/listChatUsers?token=&limit=100&activeMode=&nicknameStartswith=${name}`)
    )
    commit(types.SET_FOUND_MEMBERS, r.data)
    return r.data
  },
  async getReport({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getReport', () => http.post('chat/reportOnMessages', options))
    commit(types.SET_REPORT, r.data)
    return r.data
  },
  async getChatUserChannels({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getChatUserChannels', () =>
      http.get('chat/listChatUserChannels', {
        params: searchOptions
      })
    )
    commit(types.SET_CHANNELS, r.data)
    return r.data
  },
  async listUsers({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'listUsers', () =>
      http.get('chat/listChatUsers', {
        params: searchOptions
      })
    )
    commit(types.SET_USERS, r.data)
    return r.data
  },
  async updateUserMetadata({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateUserMetadata', () => http.post('chat/updateChatUserMetadata', data))
    return r.data
  },
  async updateUser({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateUser', () => http.post('chat/updateChatUser', data))
    return r.data
  },
  async getUserChannelCount({ commit, dispatch }, guid) {
    const r = await startLoading(dispatch, 'getUserChannelCount', () => http.get(`chat/countUserChannels?userId=${guid}`))
    commit(types.SET_USER_CHANNEL_COUNT, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chatadmin/actions.js